var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.12 17.46a3.709 3.709 0 1 1-5.245 5.245 3.709 3.709 0 0 1 5.245-5.245M26.038 10.84a5.71 5.71 0 1 1-8.076 8.075 5.71 5.71 0 0 1 8.076-8.076M11.126 17.46a3.709 3.709 0 1 1-5.245 5.245 3.709 3.709 0 0 1 5.245-5.245M42.167 34.833v-2.009a4.583 4.583 0 0 0-4.583-4.583h-1.469M1.834 34.833v-2.009a4.583 4.583 0 0 1 4.583-4.583h1.469M31.79 34.833v-2.935a6.417 6.417 0 0 0-6.418-6.417h-6.744a6.417 6.417 0 0 0-6.417 6.417v2.935",
    stroke: "#2302F5",
    strokeWidth: 2.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup);
export default __webpack_public_path__ + "static/media/user-group.136c234d9ec251819ef6f059a50fb613.svg";
export { ForwardRef as ReactComponent };